export default __webpack_public_path__ + "static/media/back_arrow.648b3458.svg";